export const toastOption = {
  className: "alert",
  duration: 2000,
  style: {
    fontWeight: 100,
  },
};
